import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { retrieveToken } from "../../../utils/storage";


export const chatbotApi = createApi({
    reducerPath: "chatbot-ia",
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL,
    }),
    tagTypes: ["chatbot, chat"],
    endpoints: (builder) => ({
        createChatbot: builder.mutation({
            query: (body) => ({
                url: `admin/chatbot/chat`,
                method: "POST",
                headers: {
                    Authorization: `Bearer ${retrieveToken()}`,
                },
                body: body,
            }),
            invalidatesTags: ["chat"],
        }),
        getAllBot: builder.query({
            query: () => ({
                url: "/admin/AiAgent",
                method: "GET",
                headers: {
                    Authorization: `Bearer ${retrieveToken()}`
                }
            }),
            providesTags: ["chatbot"]
        }),
        getBotId: builder.query({
            query: (id) => ({
                url: `/admin/AiAgent/${id}`,
                method: "GET",
                headers: {
                    Authorization: `Bearer ${retrieveToken()}`
                }
            })
        }),
        createBot: builder.mutation({
            query: (newChatbot) => ({
                url: "/admin/AiAgent",
                method: "POST",
                headers: {
                    Authorization: `Bearer ${retrieveToken()}`
                },
                body: newChatbot
            }),
            invalidatesTags: ["chatbot"]
        }),
        editBot: builder.mutation({
            query: (chatbot) => ({
                url: `/admin/AiAgent/${chatbot.id}`,
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${retrieveToken()}`
                },
                body: chatbot
            }),
            invalidatesTags: ["chatbot"]
        }),
        deleteBot: builder.mutation({
            query: (id) => ({
                url: `/admin/AiAgent/${id}`,
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${retrieveToken()}`
                },
                body: { id }
            }),
            invalidatesTags: ["chatbot"]
        })

    }),
});

export const {
    useCreateChatbotMutation,
    useGetAllBotQuery,
    useGetBotIdQuery,
    useCreateBotMutation,
    useEditBotMutation,
    useDeleteBotMutation
} = chatbotApi;